// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener('DOMContentLoaded', function() {
  const buyNowButtons = document.querySelectorAll('.btn-buy-now');

  buyNowButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      // Mostrar spinner de carga
      const spinner = button.querySelector('.loading-overlay__spinner');
      const buttonText = button.querySelector('span');

      if (spinner && buttonText) {
        spinner.classList.remove('hidden');
        buttonText.style.opacity = '0.5';
        button.disabled = true;
      }

      // Obtener datos del producto
      const variantId = button.getAttribute('data-variant-id');
      
      // Buscar quantity input de manera más flexible
      const quantityInput = findQuantityInput(button);
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      // Validar que tenemos variant ID
      if (!variantId || variantId === 'null' || variantId === '') {
        showError('Por favor selecciona una variante del producto.');
        resetButtonState(button, spinner, buttonText);
        return;
      }

      // Agregar al carrito vía AJAX
      fetch('/cart/add.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.message || 'Error al agregar al carrito');
          });
        }
        return response.json();
      })
      .then(data => {
        // Redirigir inmediatamente al checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Buy Now Error:', error);
        showError(error.message || 'Error al procesar la compra. Por favor, intenta de nuevo.');
        resetButtonState(button, spinner, buttonText);
      });
    });
  });

  // Actualizar variant ID cuando cambie la variante
  const variantSelects = document.querySelectorAll('variant-selects, variant-radios');
  variantSelects.forEach(function(variantPicker) {
    variantPicker.addEventListener('change', function() {
      const currentVariant = this.currentVariant;
      if (currentVariant) {
        updateBuyNowButtons(currentVariant);
      }
    });
  });

  // Función auxiliar para encontrar el input de cantidad
  function findQuantityInput(button) {
    // Buscar en el contexto del botón primero
    const productForm = button.closest('product-form, [data-product-form], .product-form');
    if (productForm) {
      // Buscar input de cantidad en el formulario
      const quantityInput = productForm.querySelector('input[name="quantity"], .quantity-input, [id*="quantity"], [id*="Quantity"]');
      if (quantityInput) return quantityInput;
    }

    // Buscar por patrones comunes de ID
    const possibleIds = [
      'quantity',
      'Quantity',
      'quantity-input',
      'product-quantity'
    ];

    for (const id of possibleIds) {
      const input = document.getElementById(id);
      if (input) return input;
    }

    // Buscar por selectores más generales
    return document.querySelector('input[name="quantity"]') || 
           document.querySelector('.quantity-input') ||
           document.querySelector('[data-quantity-input]');
  }

  // Función auxiliar para actualizar botones
  function updateBuyNowButtons(variant) {
    buyNowButtons.forEach(function(button) {
      button.setAttribute('data-variant-id', variant.id);
      
      // Actualizar estado de disponibilidad
      if (variant.available) {
        button.disabled = false;
        button.classList.remove('btn-unavailable');
      } else {
        button.disabled = true;
        button.classList.add('btn-unavailable');
      }
    });
  }

  // Función auxiliar para resetear estado del botón
  function resetButtonState(button, spinner, buttonText) {
    if (spinner && buttonText) {
      spinner.classList.add('hidden');
      buttonText.style.opacity = '1';
      button.disabled = false;
    }
  }

  // Función auxiliar para mostrar errores
  function showError(message) {
    // Intentar usar notificación nativa del tema si existe
    if (window.theme && window.theme.showNotification) {
      window.theme.showNotification(message, 'error');
    } else if (window.showNotification) {
      window.showNotification(message, 'error');
    } else {
      // Fallback a alert básico
      alert(message);
    }
  }

  // Función para inicializar estado de botones al cargar
  function initializeBuyNowButtons() {
    // Verificar si hay una variante seleccionada por defecto
    const variantSelector = document.querySelector('variant-selects, variant-radios');
    if (variantSelector && variantSelector.currentVariant) {
      updateBuyNowButtons(variantSelector.currentVariant);
    }
  }

  // Inicializar botones
  initializeBuyNowButtons();
});